import { Component, Input, OnInit } from '@angular/core'
import { CustomSymbology } from '@core/models/custom-symbology.model'
import { isNullOrUndefinedString } from '@services/core.utilities'

@Component({
  selector: 'app-custom-symbology',
  templateUrl: './custom-symbology.component.html',
  styleUrls: ['./custom-symbology.component.scss'],
  imports: [],
})
export class CustomSymbologyComponent implements OnInit {
  @Input() symbology: CustomSymbology[] = []

  ngOnInit() {
    if (!isNullOrUndefinedString(this.symbology)) {
      this.symbology.sort((a, b) => {
        if (+a.value > +b.value) return 1
        if (+a.value < +b.value) return -1
        return 0
      })
    }
  }
}
